import MuiIconButton, {
  IconButtonProps as MuiIconButtonProps,
} from '@mui/material/IconButton';

// Declare module augmentation for IconButtonPropsColorOverrides
declare module '@mui/material/IconButton' {
  interface IconButtonPropsColorOverrides {
    neutral: true;
    alert: true;
  }
}

export interface IconButtonProps extends MuiIconButtonProps {
  variant?: 'default' | 'tertiary';
}

export function IconButton<C extends React.ElementType = 'button'>(
  props: MuiIconButtonProps<C, { component?: C } & IconButtonProps>
) {
  const { sx, variant, color, ...otherProps } = props;
  return (
    <MuiIconButton
      color={color}
      sx={[
        {
          borderRadius: 0.5,
        },
        variant === 'tertiary' && {
          borderRadius: 0.5,
          border: '1px solid',
          borderColor: `neutral.4`,
          '&:hover': {
            bgcolor: `${color}.backgroundSoft`,
            color: `${color}.text`,
            outlineColor: 'transparent',
            borderColor: 'transparent',
            boxShadow: 'none',
          },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...otherProps}
    />
  );
}
